module.exports = __webpack_public_path__ + "assets/ee44765cbb821378a4ebd54c3b543170.mp4";